module.exports = __webpack_public_path__ + "react/assets/actions/visible-eye.png";